<div class="d-flex aligh-items-center switch-wrapper">
    <ui-switch
        (change)="handleChange($event)"
        [checked]="checked"
        [size]="size"
        [disabled]="disabled"
        class="switch-button d-flex align-self-center"
    ></ui-switch>
    <div
        class="caption d-flex ms-2 d-flex align-items-center"
        [ngClass]="{ 'font-s': size === 'small', 'font-l': size === 'large', greyed: !checked || disabled }"
        *ngIf="checkedLabel && uncheckedLabel"
    >
        <span *ngIf="checked" (click)="handleChange(false)">{{ checkedLabel }}</span>
        <span *ngIf="!checked" (click)="handleChange(true)">{{ uncheckedLabel }}</span>
    </div>
</div>
